/*****************************************************************
 * Generated by RxDjango on 2026-07-16 10:02 (UTC)               *
 *                                                               *
 * Based on all ContextChannel subclasses in list_types.channels *
 *                                                               *
 *                     DO NOT EDIT THIS FILE                     *
 *                                                               *
 * To rebuild it, run:                                           *
 *                                                               *
 *     ./manage.py makefrontend [list_types]                     *
 *                                                               *
 *****************************************************************/

import { ContextChannel } from '@rxdjango/react';

const SOCKET_URL = (process.env.REACT_APP_RX_WEBSOCKET_URL ?? 'ws://localhost:8000') as string;

export class ListTypesChannel extends ContextChannel {

  protected endpoint: string = "/ws/list_types/";
  protected baseURL: string = SOCKET_URL;

  mixed: (number | string)[] = [1, 'two', 3];
  optional_numbers: number[] | null = null;

  add_number = async (value: number) => {
    return await this.rx.callAction('add_number', [value]);
  };

  add_text = async (value: string) => {
    return await this.rx.callAction('add_text', [value]);
  };

  clear_mixed = async () => {
    return await this.rx.callAction('clear_mixed', []);
  };

  set_numbers = async (values: number[]) => {
    return await this.rx.callAction('set_numbers', [values]);
  };

  append_number = async (value: number) => {
    return await this.rx.callAction('append_number', [value]);
  };

  clear_numbers = async () => {
    return await this.rx.callAction('clear_numbers', []);
  };

  unset_numbers = async () => {
    return await this.rx.callAction('unset_numbers', []);
  };
}
